<div class="support-ticket-form-container">
  <div class="modal-header">
    <h2 class="header-text">{{ data.mode === 'create' ? 'Create Support Ticket' : (data.mode === 'view' ? 'View Support Ticket' : 'Edit
      Support Ticket') }}</h2>
    <button class="close-btn" (click)="close()" title="Close">
      <fa-icon [icon]="faTimes"></fa-icon>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-group row">
      <div class="col-md-3">
        <label>Title</label>
      </div>
      <div class="col-md-9">
        <div class="form-field">
          <input class="form-control" required [(ngModel)]="ticket.Title" name="title" [readonly]="isReadOnly()"
            placeholder="Enter ticket title" />
        </div>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-md-3">
        <label>Description</label>
      </div>
      <div class="col-md-9">
        <div class="form-field">
          <textarea class="form-control" rows="4" [(ngModel)]="ticket.Description" name="description"
            [readonly]="isReadOnly()" placeholder="Provide details about your issue or suggestion"></textarea>
        </div>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-md-3">
        <label>Type</label>
      </div>
      <div class="col-md-9">
        <div class="type-selection">
          <label class="type-option">
            <input type="radio" [disabled]="isReadOnly()" [(ngModel)]="ticket.Type" name="type" [value]="0" /> Bug
          </label>
          <label class="type-option">
            <input type="radio" [disabled]="isReadOnly()" [(ngModel)]="ticket.Type" name="type" [value]="1" />
            Suggestion
          </label>
          <label class="type-option">
            <input type="radio" [disabled]="isReadOnly()" [(ngModel)]="ticket.Type" name="type" [value]="2" /> Feedback
          </label>
          <label class="type-option">
            <input type="radio" [disabled]="isReadOnly()" [(ngModel)]="ticket.Type" name="type" [value]="3" /> Other
          </label>
        </div>
      </div>
    </div>

    <div class="form-group row" *ngIf="!isReadOnly() || ticket.ImageBase64 || ticket.ImageUrl">
      <div class="col-md-3">
        <label>Image (optional)</label>
      </div>
      <div class="col-md-9">
        <div class="image-upload-section">
          <div class="upload-controls" *ngIf="!isReadOnly()">
            <div class="file-input-wrapper">
              <input type="file" accept="image/*" (change)="onFileChange($event)" class="form-control-file" />
            </div>

            <div *ngIf="stagedFile">
              <button class="btn btn-sm btn-primary mr-2" type="button" (click)="setFile()">Set Image</button>
              <button class="btn btn-sm btn-secondary" type="button" (click)="clearStaged()">Cancel</button>
            </div>

            <div *ngIf="file && !stagedFile">
              <button class="btn btn-sm btn-secondary" type="button" (click)="clearFile()">Remove Image</button>
            </div>
          </div>

          <div class="preview-img-container" *ngIf="ticket.ImageBase64 || ticket.ImageUrl">
            <img [src]="ticket.ImageBase64 || ticket.ImageUrl" class="preview-img" alt="Support Ticket Attachment" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn btn-secondary" (click)="close()">Close</button>
    <button class="btn btn-primary" (click)="save()" [disabled]="isReadOnly() || saving">
      {{ data.mode === 'create' ? 'Create Ticket' : 'Save Changes' }}
    </button>
  </div>
</div>